module.exports = __webpack_public_path__ + "static/media/bulk_batch_assign.34c4f9f5.csv";